import { connectFela } from '../../dependencies';
import ReportGrid from './ReportGrid';
import * as styles from './ReportGrid.styles';

export default connectFela(styles)(ReportGrid);
